var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "full_layout information",
      attrs: { id: "Information" }
    },
    [
      _vm.info != null
        ? [
            _c("h3", { staticClass: "informationTitle" }, [
              _vm._v(_vm._s(_vm.info.Title))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "informationDetail" }, [
              _c("div", { staticClass: "informationAuthor" }, [
                _vm._v(
                  _vm._s(_vm.info.ReleaseTime) + " | " + _vm._s(_vm.info.Author)
                )
              ]),
              _vm._v(" "),
              _c("div", { domProps: { innerHTML: _vm._s(_vm.info.Content) } })
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ed560cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ed560cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/information/item.vue
// module id = null
// module chunks = 